module.exports = __webpack_public_path__ + "assets/media/sms-receipt.395a9eb5.mp3";